import {useState, useEffect} from 'react';
import {graphql, forecastFetchQuery} from '../../../graphql/forecastRelay';
import type {useProjectSearchQuery$data} from './__generated__/useProjectSearchQuery.graphql';

const ProjectSearchQueryDoc = graphql`
	query useProjectSearchQuery {
		viewer {
			projects(first: 100, excludeDoneOrHalted: true) {
				edges {
					node {
						id
						name
						color: projectColor
					}
				}
			}
		}
	}
`;

export interface ProjectSearchResult {
	id: string;
	name: string;
	color: string | null;
}

export function useProjectSearch(query: string) {
	const [results, setResults] = useState<ProjectSearchResult[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const trimmed = query.trim();
		if (trimmed.length < 1) {
			setResults([]);
			setLoading(false);
			return;
		}

		let cancelled = false;
		setLoading(true);

		forecastFetchQuery(ProjectSearchQueryDoc, {})
			.then(data => {
				if (cancelled) return;
				const typed = data as useProjectSearchQuery$data | null;
				const needle = trimmed.toLowerCase();
				setResults(
					(typed?.viewer?.projects?.edges ?? []).flatMap(edge =>
						edge?.node && edge.node.name.toLowerCase().includes(needle)
							? [{id: edge.node.id, name: edge.node.name, color: edge.node.color ?? null}]
							: []
					)
				);
				setLoading(false);
			})
			.catch(() => {
				if (cancelled) return;
				setResults([]);
				setLoading(false);
			});

		return () => {
			cancelled = true;
		};
	}, [query]);

	return {results, loading};
}
